export default "__VITE_ASSET__eojQoWbU__"